import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import systemRights from 'helpers/systemRights'
import { ROLES, CONFIGURATION_KEYS } from 'constants/enums'
import config from 'config'

export default class SystemRights extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired
  }

  render() {
    const { data, configuration } = this.props
    const roles = systemRights(data)
    const manageAssessorConfig =
      configuration.values[CONFIGURATION_KEYS.manageAssessors.id]

    return (
      <div>
        {roles.map((item, index) => {
          const isLast = roles.length - 1 === index
          const content = (
            <FormattedMessage
              id={item.intlKey}
              defaultMessage={item.defaultMessage}
            />
          )

          let wrappedContent = content

          if (
            item.value === ROLES.ASSESSOR.role &&
            get(manageAssessorConfig, 'booleanValue', false)
          ) {
            wrappedContent = (
              <Link
                to={`${config.publicPath}/organizations/${get(
                  data,
                  'organization.id'
                )}/assessors/${get(data, 'person.id')}/detail`}
              >
                {content}
              </Link>
            )
          }

          if (item.value === ROLES.LEADER.role) {
            wrappedContent = (
              <Link to={`${config.publicPath}/leaders/${get(data, 'id')}/detail`}>{content}</Link>
            )
          }

          return (
            <span key={index}>
              {wrappedContent}
              {!isLast && ', '}
            </span>
          )
        })}
      </div>
    )
  }
}
